// @generated by protoc-gen-es v1.2.0 with parameter "target=js+dts"
// @generated from file wavin/aqora/v2/device_test_result.proto (package wavin.aqora.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Struct, Timestamp } from "@bufbuild/protobuf";
import { Command } from "./command_pb.js";
import { Code } from "../../../google/rpc/code_pb.js";

/**
 * @generated from message wavin.aqora.v2.DeviceTestResult
 */
export const DeviceTestResult = proto3.makeMessageType(
  "wavin.aqora.v2.DeviceTestResult",
  () => [
    { no: 1, name: "device_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "summary", kind: "enum", T: proto3.getEnumType(DeviceTestResult_Summary) },
    { no: 3, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "events", kind: "message", T: DeviceTestResult_Event, repeated: true },
  ],
);

/**
 * @generated from enum wavin.aqora.v2.DeviceTestResult.Summary
 */
export const DeviceTestResult_Summary = proto3.makeEnum(
  "wavin.aqora.v2.DeviceTestResult.Summary",
  [
    {no: 0, name: "SUMMARY_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SUMMARY_SUCCESS", localName: "SUCCESS"},
    {no: 2, name: "SUMMARY_FAIL", localName: "FAIL"},
    {no: 3, name: "SUMMARY_STOP_BY_USER", localName: "STOP_BY_USER"},
  ],
);

/**
 * @generated from enum wavin.aqora.v2.DeviceTestResult.UserAction
 */
export const DeviceTestResult_UserAction = proto3.makeEnum(
  "wavin.aqora.v2.DeviceTestResult.UserAction",
  [
    {no: 0, name: "USER_ACTION_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "USER_ACTION_YES", localName: "YES"},
    {no: 2, name: "USER_ACTION_NO", localName: "NO"},
  ],
);

/**
 * @generated from message wavin.aqora.v2.DeviceTestResult.Event
 */
export const DeviceTestResult_Event = proto3.makeMessageType(
  "wavin.aqora.v2.DeviceTestResult.Event",
  () => [
    { no: 1, name: "time", kind: "message", T: Timestamp },
    { no: 2, name: "peripheral_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "attempt", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "command_event", kind: "message", T: DeviceTestResult_CommandEvent, oneof: "action" },
    { no: 5, name: "question_event", kind: "message", T: DeviceTestResult_QuestionEvent, oneof: "action" },
    { no: 6, name: "stop_button_event", kind: "message", T: DeviceTestResult_StopButtonEvent, oneof: "action" },
  ],
  {localName: "DeviceTestResult_Event"},
);

/**
 * @generated from message wavin.aqora.v2.DeviceTestResult.CommandEvent
 */
export const DeviceTestResult_CommandEvent = proto3.makeMessageType(
  "wavin.aqora.v2.DeviceTestResult.CommandEvent",
  () => [
    { no: 1, name: "command", kind: "message", T: Command },
    { no: 2, name: "response", kind: "message", T: DeviceTestResult_CommandResponse },
  ],
  {localName: "DeviceTestResult_CommandEvent"},
);

/**
 * @generated from message wavin.aqora.v2.DeviceTestResult.StopButtonEvent
 */
export const DeviceTestResult_StopButtonEvent = proto3.makeMessageType(
  "wavin.aqora.v2.DeviceTestResult.StopButtonEvent",
  [],
  {localName: "DeviceTestResult_StopButtonEvent"},
);

/**
 * @generated from message wavin.aqora.v2.DeviceTestResult.CommandResponse
 */
export const DeviceTestResult_CommandResponse = proto3.makeMessageType(
  "wavin.aqora.v2.DeviceTestResult.CommandResponse",
  () => [
    { no: 1, name: "code", kind: "enum", T: proto3.getEnumType(Code) },
    { no: 2, name: "response", kind: "message", T: Struct },
  ],
  {localName: "DeviceTestResult_CommandResponse"},
);

/**
 * @generated from message wavin.aqora.v2.DeviceTestResult.QuestionEvent
 */
export const DeviceTestResult_QuestionEvent = proto3.makeMessageType(
  "wavin.aqora.v2.DeviceTestResult.QuestionEvent",
  () => [
    { no: 1, name: "question_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "question_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_action", kind: "enum", T: proto3.getEnumType(DeviceTestResult_UserAction) },
  ],
  {localName: "DeviceTestResult_QuestionEvent"},
);

